import { SET_ASSITERS_PLAYERS } from "../constants"

export const setAssitersPlayerByTournament = (assiters)=> dispatch =>{
    dispatch({
        type: SET_ASSITERS_PLAYERS,
        payload: assiters

    })
}